import { render, staticRenderFns } from "./businessMarketservice.vue?vue&type=template&id=38e8df82&scoped=true&"
import script from "./businessMarketservice.vue?vue&type=script&lang=ts&"
export * from "./businessMarketservice.vue?vue&type=script&lang=ts&"
import style0 from "./businessMarketservice.vue?vue&type=style&index=0&id=38e8df82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e8df82",
  null
  
)

export default component.exports